import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/content';
export function FloatingElements() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [index, setIndex] = useState(0);
  const [cta, setCta] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const delay = index === 0 ? 4500 : 7500;
    const showTimer = window.setTimeout(() => setVisible(true), delay);
    const rotateTimer = window.setTimeout(() => {
      setVisible(false);
      setIndex(value => (value + 1) % recentPurchases.length);
    }, delay + 5500);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(rotateTimer);
    };
  }, [dismissed, index]);
  useEffect(() => {
    const onScroll = () => setCta(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const [name, place] = recentPurchases[index];
  return <>
      <AnimatePresence data-id="element-141" data-mp="drhuafmhkcc2">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 26,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} transition={{
        type: 'spring',
        stiffness: 280,
        damping: 24
      }} className="fixed bottom-4 left-4 z-[60] max-w-[290px] overflow-hidden rounded-2xl border-[3px] border-accent bg-primary p-3 pr-8 shadow-[0_18px_42px_rgba(14,42,28,.45)]" aria-live="polite" data-id="element-142" data-mp="dpyd8mt09x98">
            <div className="absolute inset-y-0 left-0 w-1.5 bg-accent" data-id="element-143" data-mp="11gauwpe1z8d0" />
            <button onClick={() => setDismissed(true)} className="absolute right-1.5 top-1.5 rounded p-1 text-emerald-100 transition-colors duration-150 ease-out hover:text-white" aria-label="Cerrar notificación" data-id="element-144" data-mp="15j7820ktqc9k">
              <XIcon className="h-3.5 w-3.5" data-id="element-145" data-mp="32jborzu7p80h" />
            </button>
            <div className="flex gap-3" data-id="element-146" data-mp="32kwglhp56cun">
              <span className="h-fit rounded-full border-2 border-orange-100 bg-accent p-2 text-white shadow-sm" data-id="element-147" data-mp="3gazzbyotbofc">
                <ShoppingBagIcon className="h-5 w-5" data-id="element-148" data-mp="3bjhvn2ven9qo" />
              </span>
              <div data-id="element-149" data-mp="3q8e3aytjukqr">
                <p className="flex items-center gap-1 text-[10px] font-black uppercase tracking-[.12em] text-orange-200" data-id="element-150" data-mp="3q7uvwc1izeqz">
                  <CheckCircle2Icon className="h-3 w-3" data-id="element-151" data-mp="3l8rt6y90pkm6" /> Compra reciente
                </p>
                <p className="mt-1 text-xs leading-snug text-emerald-50" data-id="element-152" data-mp="32n6srbfzpvl">
                  <b className="text-white" data-id="element-153" data-mp="3u9pu37o5tc0j">{name}</b> compró el libro digital{' '}
                  <b className="text-orange-200" data-id="element-154" data-mp="24v1kfe6ye867">Facial PRO 2026</b>
                </p>
                <p className="mt-1 flex items-center gap-1 text-[10px] font-semibold text-emerald-100" data-id="element-155" data-mp="1zw865jjued4z">
                  <MapPinIcon className="h-3 w-3 text-orange-200" data-id="element-156" data-mp="fe5z3gmnbodf" />
                  {place} · Argentina · hace {index * 4 + 2} min
                </p>
              </div>
            </div>
          </motion.aside>}
      </AnimatePresence>

      <AnimatePresence data-id="element-157" data-mp="6l2qblmy3zp4">
        {cta && <motion.a href="#pricing" initial={{
        y: 80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 80,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-3 left-3 right-3 z-50 rounded-2xl bg-primary py-3.5 text-center text-sm font-extrabold uppercase text-white shadow-lg shadow-primary/30 md:hidden" data-id="element-158" data-mp="6k1c58amux36">
            🧴 Quiero mi Facial PRO →
          </motion.a>}
      </AnimatePresence>
    </>;
}